import { render, staticRenderFns } from "./InputProperties.vue?vue&type=template&id=c20f30e0&scoped=true&"
import script from "./InputProperties.vue?vue&type=script&lang=js&"
export * from "./InputProperties.vue?vue&type=script&lang=js&"
import style0 from "./InputProperties.vue?vue&type=style&index=0&id=c20f30e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20f30e0",
  null
  
)

component.options.__file = "InputProperties.vue"
export default component.exports